import { useEffect, useState } from "react";
import { api } from "@/api";

function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-CA", { day: "2-digit", month: "short" });
  } catch { return iso; }
}

/**
 * Iter99 — Widget Leads : nom + email + message (si présent).
 * Aucun lien, aucune action cliquable.
 */
export default function LeadsWidget() {
  const [data, setData] = useState({ items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/leads?limit=5")
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [] }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center text-gray-300 text-sm py-4">·</div>;
  if (!data.items || data.items.length === 0) return null;

  return (
    <div className="animate-fade-in" data-testid="widget-leads">
      <ul className="space-y-2 max-h-[280px] overflow-y-auto">
        {data.items.map((lead, i) => (
          <li
            key={i}
            className="border border-gray-100 rounded-lg p-2.5 bg-white"
            data-testid={`widget-lead-${i}`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="font-medium text-sm text-gray-900 truncate">
                {lead.nom || "(anonyme)"}
              </div>
              <span className="text-[10px] text-gray-400 shrink-0">{fmtDate(lead.created_at)}</span>
            </div>
            {lead.email && (
              <div className="text-[11px] text-gray-500 truncate mt-0.5">{lead.email}</div>
            )}
            {lead.message && (
              <p className="text-xs text-gray-600 mt-1 line-clamp-2">{lead.message}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
